import React, { useEffect, useState } from 'react'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import { Container, Row, Col } from 'react-bootstrap'
import CartService from '../services/Cart';
import DefaultImage from '../assets/images/productDefault.png'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import RegistrationService from '../services/registration';
import Loader from '../component/Loader'
import OrderService from '../services/Order';
import PrimaryGradientButton from '../component/PrimaryGradientButton';
import AlertMsg from '../component/AlertMsg'
import Animation1 from '../assets/images/anim1.gif'
import Animation2 from '../assets/images/anim2.gif'
import Animation3 from '../assets/images/anim3.gif'
import { addTotalBellItems, addTotalCartItems } from '../redux/slices/countSlice';
import { Home } from 'react-feather';
import OtherService from '../services/Other';
import ProfileService from '../services/Profile';
import { useDispatch } from 'react-redux';
import { addUserData, addPersonalInfoResponse } from '../redux/slices/userTypeSlice';
import { formatNumberWithCommas } from '../constants/commonFunction';
import toast from 'react-hot-toast';
import useScrollToTop from '../hooks/useScrollToTop';
import PrimaryOutLineButton from '../component/PrimaryOutLineButton';
import DOMPurify from "dompurify";
import { parseSafeHtml } from "../utils/safeHtmlParser";

const PlaceOrder = () => {
    useScrollToTop()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [cartList, setCartList] = useState();
    const [isPointSummary, setIsPointSummary] = useState();
    const [isGrossUpValue, setIsGrossUpValue] = useState();
    const [isCartId, setCartId] = useState();
    const [isCatalogeId, setCatalogeId] = useState();
    const [loading, setLoading] = useState(true);
    const [apiLoading, setApiLoading] = useState(false);
    const [isUser, setIsUser] = useState({ full_name: '', phone: '' })
    const location = useLocation();
    const [isLoginSuccess, setIsLoginSuccess] = useState({ isLogin: true, heading: '', text: '' })
    const [showAlert, setShowAlert] = useState(false);
    const [isDataShowBlock, setIsDataShowBlock] = useState(true)
    const [grossUp, setGrossUp] = useState(0)
    const [imageSuccessBlock,setImageSuccessBlock] = useState(false)
    const [isAddress, setIsAddress] = useState({
        line1: '',
        line2: '',
        line3: '',
        post_code: ''
    })
    const [showTds, setShowTds] = useState(false);
    const [total, setTotal] = useState('');
    const [borderActive, setBorderActive] = useState(true)

    const changeBgColor = () => {
        
        if(window.scrollY < 70) {
            setBorderActive(true)
        } else {
            setBorderActive(false)
        }
    }

    window.addEventListener('scroll', changeBgColor)
    // const [grossupValue, setGrossupValue] = useState('');
    // const selectedAddress = location.state.selectedAddressDelivery;

    const { addressId } = useParams();
    
    //Address Data
    useEffect(() => {
        const AddressFetchData = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const AddressFetchResponse = await OtherService.addressListById(addressId)
                if (JSON.stringify(AddressFetchResponse) != '{}' && AddressFetchResponse.data.status === true && JSON.stringify(AddressFetchResponse.data.addressDetails) != '{}') {
                    setIsAddress(AddressFetchResponse.data.addressDetails)
                    setLoading(false)
                }
                else {
                    setIsAddress(AddressFetchResponse.data.message)
                   
                }
            }
            catch (error) {
                console.error("Address Fetch")
            }

        }
        AddressFetchData()

    }, [])
    //Cart Data
    useEffect(() => {
        const CartFetchData = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const CartFetchDataResponse = await CartService.myCartItems(token);
                if (CartFetchDataResponse.data && CartFetchDataResponse.data.cart_data && CartFetchDataResponse.data.cart_data.control) {
                    setIsGrossUpValue(CartFetchDataResponse.data?.cart_data.control.grandtotal_in_point)
                    setTotal(CartFetchDataResponse.data.cart_data.control.grandtotal_in_point);
                    setCartId(CartFetchDataResponse.data.cart_id)
                    setCatalogeId(CartFetchDataResponse.data.cart_data.control.cart_catalog_id)
                    setLoading(false)
                }
                if (CartFetchDataResponse.data && CartFetchDataResponse.data.cart_data && CartFetchDataResponse.data.cart_data.row_items) {
                    const cartItemsObject = Object.keys(CartFetchDataResponse.data.cart_data.row_items)
                    if (cartItemsObject.length > 0) {
                        const cartItemArray = cartItemsObject.map(key => CartFetchDataResponse.data.cart_data.row_items[key]);
                        setCartList(cartItemArray);
                        setLoading(false)
                    }
                }
            } catch (error) {
                console.error("CartFetchData");
            }
        };

        CartFetchData();

    }, []);
    //Name Info
    useEffect(() => {
        const UserNameFetchData = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const UserNameFetchResponse = await RegistrationService.getBasicProfileInfo(token);

                if (UserNameFetchResponse.success == true) {
                    setIsUser(UserNameFetchResponse.response.basicProfileDetails)
                    setLoading(false)
                }

            }
            catch (error) {
                console.error("User Name Fetch")

            }

        }
        UserNameFetchData()
    }, [])

    //Point Summary
    useEffect(() => {
        const PointSummaryFetchData = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const PointSummaryDataResponse = await OrderService.tdsData('null');
                if (PointSummaryDataResponse.response_code == 200) {
                    setIsPointSummary(PointSummaryDataResponse.data.balance)
                    if (PointSummaryDataResponse.data.is_tds_block == 0) {
                        setShowTds(false);
                        setGrossUp(isGrossUpValue);
                    } else {
                        // setIsGrossUpValue(PointSummaryDataResponse.data.balance.grossup_value)
                        setShowTds(true);
                        // setIsGrossUpValue(PointSummaryDataResponse.data.balance.grossup_value)
                        setTotal(PointSummaryDataResponse.data.balance.total_point_spent_price);
                        setGrossUp(PointSummaryDataResponse.data.balance.grossup_value)
                    }
                    setLoading(false)
                }
            } catch (error) {
                console.error("Point Summary Data Response")
            }
        };

        PointSummaryFetchData();
    }, [isGrossUpValue]);
   
       
  
    const handleCheckout = async () => {
        const token = localStorage.getItem('access_token');
        const userInfo = JSON.parse(localStorage.getItem('userData'));
        const payload = {
            catalogId: isCatalogeId + '',
            panId: 2,
            addressId: parseInt(addressId),
            cartIdVal: parseInt(isCartId),
            declarePan: '1',
            contractorHierarchyId: parseInt(userInfo.dcm_hierarchies_id),
        };
        console.log("payload", JSON.stringify(payload))
        try {
            setApiLoading(true)
            const PlaceOrderSubmit = await CartService.checkoutOrder(payload)
            setApiLoading(false)
             console.log("PlaceOrderSubmit", JSON.stringify(PlaceOrderSubmit))
            if (PlaceOrderSubmit.data.status == true) {
                setIsDataShowBlock(false)
                dispatch(addTotalCartItems({
                    cartCount:0
                }))
                try {
                    const contactId = userInfo.dcm_contacts_id;
                    const personalInfoResponse = await ProfileService.getProfile(contactId, token);
                    if (personalInfoResponse.success == true && personalInfoResponse.response.message != null) {
                        dispatch(addUserData({ userData: personalInfoResponse.response.message }))
                        dispatch(addPersonalInfoResponse({ personalInfoResponse: personalInfoResponse }))
                    }
                } catch (error) {
                    console.error("Post Order Profile Refresh Error")
                }
                setShowAlert(true)
                toast.success(PlaceOrderSubmit?.data?.message)
                // setIsLoginSuccess({ isLogin: true, text: `Your Order Id is ${PlaceOrderSubmit.data.order_id}. ${PlaceOrderSubmit.data.message}` })
                setImageSuccessBlock(true)
                setTimeout(() => {
                    navigate('/my-orders')
                }, 5000)
    
    
            }
    
            else {
                // setIsDataShowBlock(false)
                // setShowAlert(true)
                toast.error( PlaceOrderSubmit.data.message)
                // setIsLoginSuccess({ isLogin: false, text: PlaceOrderSubmit.data.message })
                // setTimeout(()=>{
                // // setShowAlert(true)
                // navigate('/landing')
                // },6000)
            }

        } catch(err) {
            setApiLoading(false)
        }

    }
    return (
        <>
            {loading && <Loader />}
            <BreadCrumbSecttion
                pageTitle="Place Order"
                currentPageName="Place Order"
            />
            <section className='padTop50 position-relative'>

                {showAlert &&
                    <Container>
                        <Row className="justify-content-center">
                           
                                
                            
                            <Col xs={12} lg={6}>
                               {imageSuccessBlock && <img src={Animation3} alt='animation' className='middleImg' />}
                                {/* <AlertMsg alertBoxColor={isLoginSuccess.isLogin ? 'successAlert' : 'FailedAlert'}
                                    heading={isLoginSuccess.heading}
                                    text={isLoginSuccess.text}
                                /> */}
                            </Col>
                        </Row>
                    </Container>

                }

                {isDataShowBlock && <>
                    <Container>
                        <Row>
                            <Col xs={12} className='addressBblockWrap'>
                                <div className='addressBblock stickyBlock'>
                                    <div className='deliveryDetailsBlock'>
                                        <Row>
                                            <Col xs={12}>
                                                <div className='addressBlockWrap'>
                                                    <div className='addressBlockArea'>
                                                        <p>Point Summary</p>
                                                        <div className='addressBlockArea'>
                                                            <div className='addressTxtWrap'><div className='firstBlock'>Order Total</div><div className='secondBlock'>{formatNumberWithCommas(isGrossUpValue)} Points</div></div>
                                                            {showTds && <div className='addressTxtWrap'><div className='firstBlock'>Current TDS Amount </div><div className='secondBlock'>{formatNumberWithCommas(isPointSummary?.current_tds_amount)} Points</div></div>}
                                                            <div className='addressTxtWrap'><div className='firstBlock'>Gross Up Value</div><div className='secondBlock'>{formatNumberWithCommas(grossUp)} Points</div></div>
                                                            <div className='addressTxtWrap'><div className='firstBlock'>Total order {'\n'}(Incl. Blocked TDS)</div><div className='secondBlock'><b>{formatNumberWithCommas(total)} Points</b></div></div>
                                                            
                                                        </div>

                                                    </div>
                                                </div>
                                            </Col>
                                            <Col xs={12}>
                                                <div className='addressBlockWrap'>
                                                    <div className='addressBlockArea'>
                                                        <p>Billing Address</p>
                                                        {isUser?.full_name && <div className='addressTxtWrap'><div className='firstBlock'>Name</div><div className='secondBlock'>{isUser?.full_name}</div></div>}
                                                        {isAddress?.line1 &&<div className='addressTxtWrap'><div className='firstBlock'>Address</div><div className='secondBlock'>{isAddress?.line1}{isAddress?.line2}{isAddress?.line3}</div></div>}
                                                        {/* {isAddress?.city && <div className='addressTxtWrap'><div className='firstBlock'>City </div><div className='secondBlock'>{isAddress?.city}</div></div>} */}
                                                        {isAddress?.city && <div className='addressTxtWrap'><div className='firstBlock'>District </div><div className='secondBlock'>{isAddress?.district_name}</div></div>}
                                                        {isAddress?.city && <div className='addressTxtWrap'><div className='firstBlock'>State </div><div className='secondBlock'>{isAddress?.state_name}</div></div>}
                                                        {isAddress?.post_code && <div className='addressTxtWrap'><div className='firstBlock'>PostCode</div><div className='secondBlock'>{isAddress?.post_code}</div></div>}
                                                        {isUser?.phone && <div className='addressTxtWrap'><div className='firstBlock'>Phone No</div><div className='secondBlock'>{isUser?.phone}</div></div>}

                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                                <div className='productBblock'>

                                    <div className='placeOrderItem'>
                                        {cartList?.map((item, index) => {
                                            const { product_image, product_id, price_in_points, product_name, product_desc, quantity } = item;
                                            const imgSrc = product_image.length > 0 ? product_image : DefaultImage;
                                            return (
                                                <Row key={index}>
                                                    <Col xs={12}>
                                                        <div className='placeOrderitemProduct' >

                                                            <div className="itemProductWrapMyOrderBlock">
                                                                <div className="itemWrapImageMyOrderPlaceOrder">
                                                                    <div className="itemWrapImageMyOrder">
                                                                        <img src={imgSrc} alt={product_name} />
                                                                    </div>
                                                                </div>
                                                                <div className="itemWrapImageTxtMyOrder">
                                                                    <div className="titleTxt">{product_name}</div>
                                                                    {/* <div className="productDescTxt" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(product_desc)}}/> */}
                                                                    <div className="productDescTxt">{parseSafeHtml(product_desc)}</div>
                                                                    <div className="quantityTxtPo"><p>Quantity:</p><p>{quantity}</p></div>
                                                                    <div className="quantityTxtPo"><p>Points:</p> <p>{price_in_points}</p></div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </Col>
                                                </Row>
                                            )
                                        })}
                                    </div>
                                </div>
                                <div className='clearfix'></div>
                            </Col>

                        </Row>
                    </Container>
                    <Row className={`buttonWrapBottom transition-2 sticky-bottom ${borderActive? 'border-active':''}`}>
                     <Col xs={12} md ={6} lg={3}>
                         <PrimaryOutLineButton outlinebuttonText="Back" onClick={() => { navigate(-1) }}
                         />
                     </Col>
            
                     <Col xs={12} md ={6} lg={3}> 
                     <PrimaryGradientButton disabled={apiLoading} buttonText="Checkout" onClick={handleCheckout} />
                         </Col>
                    </Row>
                </>
                     
                }
            </section>
        </>
    )
}


export default PlaceOrder